'use client';

import { FC, useEffect } from 'react';

import { ServerSideErrorPage } from '@telialt/core-nextjs/src/components/Error/ServerSideErrorPage';
import { QueryProvider } from '@telialt/core-nextjs/src/components/Providers/QueryProvider';
import { StyledComponentsProvider } from '@telialt/core-nextjs/src/components/Providers/StyledComponentsProvider';
import { datadogLogger } from '@telialt/utils/src/datadog/datadogLogger';
import { DDComponent } from '@telialt/utils/src/datadog/setup';

const NotFound: FC = () => {
    useEffect(() => {
        const datadogLogs = datadogLogger();
        datadogLogs.error(`Page load Error. Code: 404`, { component: DDComponent.Eshop });
    }, []);

    return (
        <html lang="lt">
            <body>
                <QueryProvider>
                    <StyledComponentsProvider>
                        <ServerSideErrorPage />
                    </StyledComponentsProvider>
                </QueryProvider>
            </body>
        </html>
    );
};
export default NotFound;
